import styled from 'styled-components';

export const Container = styled.section`
  background: #fff;
  padding: 2rem;
  border-radius: 0.25rem;

  h2 {
    color: var(--text-title);
    font-size: 2.5rem;
    font-weight: 600;
    margin-bottom: 1rem;
  }

  p {
    display: inline-block;
    font-size: 1.2rem !important;
    margin: 0 0 1.5rem 0;
    color: var(--text-title);
  }

  input {
    width: 100%;
    padding: 0 1.5rem;
    height: 4rem;
    border-radius: 0.25rem;

    border: 1px solid #d7d7d7;
    background: var(--input-background);

    font-weight: 400;
    font-size: 1rem;

    &::placeholder {
      color: var(--text-body);
    }

    /* PasswordInput envolve o <input> num <div>, então o seletor
       irmão precisa cobrir input+input, input+div e div+div. */
    & + input,
    & + div {
      margin-top: 1rem;
    }
  }

  div + div {
    margin-top: 1rem;
  }

  button[type='submit'] {
    width: 100%;
    padding: 0 1.5rem;
    height: 4rem;
    background: var(--green);
    color: #fff;
    border-radius: 0.25rem;
    border: 0;
    font-size: 1rem;
    margin-top: 1.5rem;
    font-weight: 600;

    transition: filter 0.2s;

    &:hover {
      filter: brightness(0.9);
    }
  }

  .secondButton {
    width: 100%;
    padding: 0 1.5rem;
    height: 4rem;
    background: var(--blue);
    color: #fff;
    border-radius: 0.25rem;
    border: 0;
    font-size: 1rem;
    margin-top: 1.5rem;
    font-weight: 600;

    transition: filter 0.2s;

    &:hover {
      filter: brightness(0.9);
    }
  }

  span {
    display: inline-block;
    font-size: 1rem;
    margin-top: 1.5rem;
    color: var(--text-title);
  }

  @media (prefers-reduced-motion: reduce) {
    button[type='submit'],
    .secondButton {
      transition: none;
    }
  }
`;
